import { motion } from "framer-motion";

export const SectionHeading = ({ eyebrow, title, text, dark = false, testid }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    className="max-w-2xl"
  >
    <p data-testid={`${testid}-eyebrow`} className="font-display text-[#e2001a] font-semibold tracking-[0.28em] uppercase text-xs mb-4 flex items-center gap-3">
      <span className="inline-block w-8 h-[2px] bg-[#e2001a]" />
      {eyebrow}
    </p>
    <h2 data-testid={`${testid}-title`} className={`font-display font-bold text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight ${dark ? "text-white" : "text-[#1a1d20]"}`}>
      {title}
    </h2>
    {text && (
      <p data-testid={`${testid}-text`} className={`mt-5 text-base sm:text-lg leading-relaxed ${dark ? "text-white/60" : "text-[#1a1d20]/65"}`}>
        {text}
      </p>
    )}
  </motion.div>
);
